import React, { Component } from 'react';
import logo from './../assets/cosmowhite.png'

class Album extends Component {
    constructor() {
        super();
        this.spinner = React.createRef();
        this.state = { loadedItems: [] };
    }
    onLoad(feedItem) {
        this.setState(({ loadedItems }) => {
            return { loadedItems: loadedItems.concat(feedItem) }
        })
    }
    artist(isArtist = false) {
        var title = this.props.track.title.replace(/^.+:/, "")
        title = title.replace(/\[.+\]/, "")
        var artist = title.split(/[:-]/)
        switch (artist.length) {
            case 1:
                var Artist = artist[0].split(/'.+'/)
                var Title = artist[0].replace(Artist[0], "")
                break;
            case 2:
                Artist = artist[0]
                Title = artist[1]
                break;
            case 3:
                Artist = artist[0]
                Title = artist.slice(1)
                break;
        }
        if (isArtist) {
            return Artist
        } else {
            return Title
        }
    }
    render() {
        var track = this.props.track
        var key = this.props.ind
        var imgLink = this.props.imgLink
        var className = ""
        var turnCosmo = ""

       if (this.props.currentTrack === track.id && this.props.search != track.id){  
            className = 'Playing'
            turnCosmo =  this.props.isPaused === false ? 'TurnCosmo' : 'PlayCosmo';
       }
         else {
            className = this.props.active === key ? 'Playing' : 'HoverPlay';
            turnCosmo = this.props.active === key ? 'TurnCosmo' : 'PlayCosmo';
        }
        const href = window.location.href != window.location.hostname ? window.location.href + "#Disco/Funk" : window.location.href
        return (
            <div
                key={key}
                className="track"
                href={void (0)}
                onClick={() => {
                    window.location.href = "#" + this.props.genre + "?track=" + track.id
                    document.title = this.props.genre + "-" + track.user.username;
                    this.props.onClick(this.props.ind, track, this.spinner.current);
                }}
            >
                <img className="artwork" src={imgLink} onLoad={this.onLoad.bind(this, imgLink)} />
                <div className={className}>
                    <img id={key} ref={this.spinner} className={turnCosmo} src={logo} />
                </div>
                <div className="titleContainer">
                    <div className="songTitle">
                        {
                            this.artist()
                        }
                    </div>
                    <div className="Artist">
                        {
                            this.artist(true)
                        }
                    </div>
                </div>
            </div>
        )
    }
}
export default Album;


// WEBPACK FOOTER //
// ./src/components/Album.js